import { getIsSalesSpaceChannelType } from '../../channel/channelSelectors';
import { getIsAgent } from '../../currentUser/currentUserSelectors';
import { channelRemoved } from '../channelsSlice';

const handleChannelLeft =
  ({ channelId }) =>
  async (dispatch, getState) => {
    const isAgent = getIsAgent(getState());
    const isSalesSpace = getIsSalesSpaceChannelType(channelId)(getState());

    // remove channel only if it's not unjoined agent from the sales-space;
    if (!isSalesSpace && !isAgent) {
      dispatch(channelRemoved({ channelId }));
    }
  };

export default handleChannelLeft;
